/* eslint-env jquery */

"use strict";

const { pruneProductSlides } = require("../utils/carouselSlides");

function initStaticSwipers() {
    const Swiper = require("swiper").default;
    const { Navigation, Pagination, Scrollbar, Thumbs } = require("swiper");

    $(".js-swiper-carousel").each(function () {
        const $wrapper = $(this);
        const $container = $wrapper.find(".js-swiper-container");

        if (!$container.length || $container[0].swiper) return;

        pruneProductSlides($container, $wrapper);

        const slidesToShow = parseInt($wrapper.data("slides-to-show"), 10) || 5;
        const slidesToShowXL = parseInt($wrapper.data("slides-to-show-xl"), 10) || null;
        const slidesToShowMobile = parseInt($wrapper.data("slides-to-show-mobile"), 10) || 2;
        const spacing = parseInt($wrapper.data("spacing"), 10) || 16;

        const modules = [];
        if ($wrapper.data("navigation-enabled")) modules.push(Navigation);
        if ($wrapper.data("pagination-enabled")) modules.push(Pagination);
        if ($wrapper.data("scroll-enabled")) modules.push(Scrollbar);
        if ($wrapper.data("sync-carousel-id")) modules.push(Thumbs);

        const options = {
            modules,
            loop: Boolean($wrapper.data("loop-enabled")),
            direction: $wrapper.data("direction") || "horizontal",
            slideToClickedSlide: !!$wrapper.data("clickable-slide"),
            slidesPerView: slidesToShowMobile,
            spaceBetween: spacing,
            breakpoints: {
                1024: {
                    slidesPerView: slidesToShow,
                    spaceBetween: spacing
                }
            },
            navigation: {
                nextEl: $wrapper.find(".js-swiper-button-next")[0],
                prevEl: $wrapper.find(".js-swiper-button-prev")[0]
            },
            pagination: {
                el: $wrapper.find(".js-swiper-pagination")[0],
                type: "bullets",
                clickable: true
            },
            scrollbar: {
                el: $wrapper.find(".js-swiper-scrollbar")[0]
            }
        };

        if (slidesToShowXL !== null) {
            options.breakpoints[1400] = {
                slidesPerView: slidesToShowXL,
                spaceBetween: spacing
            };
        }

        const syncedId = $wrapper.data("sync-carousel-id");
        if (syncedId) {
            const thumbEl = $(".image-carrousel__thumbnails .swiper")[0];
            if (thumbEl && thumbEl.swiper) {
                options.thumbs = { swiper: thumbEl.swiper };
            }
        }

        new Swiper($container[0], options);
    });
}

function initSlotCarousel(node) {
    const Swiper = require("swiper").default;
    const { Navigation, Pagination } = require("swiper");

    const $wrapper = $(node).hasClass("js-swiper-carousel-slot")
        ? $(node)
        : $(node).find(".js-swiper-carousel-slot");

    if (!$wrapper.length) return;

    const $container = $wrapper.find(".ahumada-recommendation-carousel-swiper");

    if (!$container.length || $container[0].swiper) return;

    pruneProductSlides($container, $wrapper);

    const slidesToShow = parseInt($wrapper.data("slides-to-show"), 10) || 4;
    const slidesToShowMobile = parseInt($wrapper.data("slides-to-show-mobile"), 10) || 2;
    const spacing = parseInt($wrapper.data("spacing"), 10) || 16;

    const options = {
        modules: [Navigation, Pagination],
        loop: Boolean($wrapper.data("loop-enabled")),
        direction: $wrapper.data("direction") || "horizontal",
        slidesPerView: slidesToShowMobile,
        spaceBetween: spacing,
        breakpoints: {
            1024: {
                slidesPerView: slidesToShow,
                spaceBetween: spacing
            }
        },
        navigation: {
            nextEl: $wrapper.find(".js-swiper-button-next")[0],
            prevEl: $wrapper.find(".js-swiper-button-prev")[0]
        },
        pagination: {
            el: $wrapper.find(".js-swiper-pagination")[0],
            type: "bullets",
            clickable: true
        }
    };

    new Swiper($container[0], options);

    const { initPopover } = require("../../js/utils/popoverUtils");
    initPopover();
}

window.addEventListener("load", () => {
    initStaticSwipers();
});

const observer = new MutationObserver(mutations => {
    for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
            if (
                node.nodeType === 1 &&
                (node.matches?.(".js-swiper-carousel-slot") ||
                 node.querySelector?.(".js-swiper-carousel-slot"))
            ) {
                initSlotCarousel(node);
            }
        }
    }
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});
